/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPhysioCategory } from 'app/shared/model/physio-category.model';
import { IHospital } from 'app/shared/model/hospital.model';

export interface IPhysioItem {
  id?: string;
  active?: boolean;
  lastupdated?: number | null;
  measurement?: string | null;
  methodName?: string | null;
  sortOrder?: number;
  testLocalAbbrev?: string | null;
  testName?: string | null;
  timestampentry?: number;
  microSec?: number;
  cursor?: number;
  charge?: number | null;
  category?: IPhysioCategory;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<IPhysioItem> = {
  active: false,
};
